__turbopack_context__.v({
  "className": "gsfont_6741f8df-module__zDBQ4a__className",
});
